/**
 * @author lifei
 * 功能： action 模块
 *
 */
import { Login } from './login'
import { Tab } from './tab'
import { Favorite } from './favorite'
import { Common } from './common'
import { Oss } from './oss'

export class Actions {
  /**
   * 功能：login
   */
  static login = new Login()

  /**
   * 功能：页签管理
   */
  static tab = new Tab<TCommon.TStore.State>()

  /**
   * 功能：页签收藏管理
   */
  static favorite = new Favorite()

  /**
   * 功能：公用模块
   */
  static common = new Common()

  /**
   * 功能：oss 操作
   */
  static oss = new Oss()
}
